type ResponsiveImageProps = {
  imageUrl?: string;
  className?: string
  onClick?: () => void;
};

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({ imageUrl, className, onClick }) => {
  if (!imageUrl) return
  return (
    <div>
      <div className="overflow-hidden">
        <img
          src={imageUrl}
          alt="Cover"
          className={`w-full border border-gray-200 rounded-xl dark:border-gray-700 ${className}`}
          onClick={onClick}
        />
      </div>
    </div>
  );
}

export default ResponsiveImage
